export enum JobType {
  GENERAL,
  INSPECTION,
  ISSUE,
  MAINTENANCE,
  WORK_ORDER,
  MILL_ORDER,
}

export enum JobLabelType {
  GENERAL = 'General',
  INSPECTION = 'Inspection',
  ISSUE = 'Issue',
  MAINTENANCE = 'Maintenance',
  WORK_ORDER = 'Purchase order',
  MILL_ORDER = 'Mill order',
}

export default JobType
